;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('DeleteCategoryController', DeleteCategoryController)

  DeleteCategoryController.$inject = ['$uibModalInstance']

  function DeleteCategoryController ($uibModalInstance) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      })
    }
    function accept () {
      $uibModalInstance.close(true)
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
